import { LinearProgress } from '@mui/material';
import React from 'react';

export interface PollLinearProgressProps {
  value: number;
}

export function PollLinearProgress({ value }: PollLinearProgressProps) {
  return <LinearProgress color="inherit" style={{ height: 5, width: '100%' }} variant="determinate" value={value} />;
}
